import { useRef, useState } from "react";
import clinicAPI from "../../../services/clinicApi";
import { HubSheet, HubSheetActions } from "../AdminPortal/HubPwa";
import aa from "../AdminPortal/adminApp.module.css";
import s from "../clinic.module.css";
import { Button, Modal, useToast } from "../../ui";

const SAMPLE = `full_name,email,phone,date_of_birth,gender,rank_belt,allergies,mis_external_id
Иванов Иван,ivan@mail.ru,+79001234567,1990-05-15,male,,,,,
Петрова Анна,,+79007654321,1985-11-02,female,,,,`;

function ImportBody({ csv, setCsv, fileRef, readFile, result }) {
  return (
    <>
      <p className={aa.hubHint}>
        Обязательно: имя. Желательно: телефон или email. Дубликаты по email
        пропускаются.
      </p>

      <div
        className={aa.importDropzone}
        onClick={() => fileRef.current?.click()}
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => {
          e.preventDefault();
          const f = e.dataTransfer.files?.[0];
          if (f) readFile(f);
        }}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") fileRef.current?.click();
        }}
      >
        <input
          ref={fileRef}
          type="file"
          accept=".csv,text/csv"
          hidden
          onChange={(e) => {
            const f = e.target.files?.[0];
            if (f) readFile(f);
          }}
        />
        <strong>Выберите CSV-файл</strong>
        <span>или перетащите сюда</span>
      </div>

      <textarea
        className={aa.importTextarea}
        rows={8}
        value={csv}
        onChange={(e) => setCsv(e.target.value)}
        placeholder={SAMPLE}
        aria-label="Текст CSV"
      />

      {result ? (
        <div className={aa.importResult}>
          <p>
            Создано: <strong>{result.created}</strong> · Пропущено:{" "}
            <strong>{result.skipped}</strong>
          </p>
          {result.errors?.length > 0 ? (
            <ul className={s.importErrors}>
              {result.errors.slice(0, 6).map((err, i) => (
                <li key={i}>
                  Строка {err.line}: {err.error}
                </li>
              ))}
              {result.errors.length > 6 ? (
                <li>…ещё {result.errors.length - 6} ошибок</li>
              ) : null}
            </ul>
          ) : null}
        </div>
      ) : null}
    </>
  );
}

export default function AdminPatientImport({ open, onClose, onImported, appMode = false }) {
  const toast = useToast();
  const fileRef = useRef(null);
  const [csv, setCsv] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const readFile = (file) => {
    const reader = new FileReader();
    reader.onload = () => setCsv(String(reader.result || ""));
    reader.readAsText(file, "UTF-8");
  };

  const submit = async () => {
    if (!csv.trim()) {
      toast.error("Выберите файл или вставьте CSV");
      return;
    }
    setLoading(true);
    setResult(null);
    try {
      const r = await clinicAPI.importPatientsCsv(csv);
      setResult(r);
      toast.success(r.message || "Импорт завершён");
      onImported?.();
    } catch (e) {
      toast.error(e.response?.data?.error || "Ошибка импорта");
    } finally {
      setLoading(false);
    }
  };

  const close = () => {
    setResult(null);
    setCsv("");
    onClose?.();
  };

  if (appMode) {
    return (
      <HubSheet
        open={open}
        onClose={close}
        title="Импорт клиентов"
        subtitle="Загрузите CSV со списком учеников"
        titleId="client-import-sheet-title"
        footer={
          <HubSheetActions
            primary={loading ? "Импорт…" : "Импортировать"}
            primaryDisabled={loading || !csv.trim()}
            onPrimary={submit}
            secondaryLabel="Закрыть"
            onSecondary={close}
          />
        }
      >
        <ImportBody
          csv={csv}
          setCsv={setCsv}
          fileRef={fileRef}
          readFile={readFile}
          result={result}
        />
        <button
          type="button"
          className={aa.importSampleBtn}
          onClick={() => setCsv(SAMPLE)}
        >
          Вставить пример
        </button>
      </HubSheet>
    );
  }

  return (
    <Modal open={open} onClose={close} title="Импорт клиентов из CSV">
      <div className={s.importPanel}>
        <ImportBody
          csv={csv}
          setCsv={setCsv}
          fileRef={fileRef}
          readFile={readFile}
          result={result}
        />

        <div className={s.scheduleActions}>
          <Button type="button" variant="secondary" onClick={() => setCsv(SAMPLE)}>
            Пример
          </Button>
          <Button type="button" variant="secondary" onClick={close}>
            Закрыть
          </Button>
          <Button type="button" onClick={submit} disabled={loading}>
            {loading ? "Импорт…" : "Импортировать"}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
